import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { IIncomeReceipt, IReceiptsTaxTaxpayerResponse } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxpayersTaxStore extends ListStore<IReceiptsTaxTaxpayerResponse> {
  @override
  filters = {
    month: '2023-05',
  };
  @observable overall = {
    totalSumReceipt: 0,
  };
  @observable currentTaxpayer = '';
  @observable totalPages = 0;

  sortColumns: (keyof IIncomeReceipt)[] = ['date', 'sumReceipt'];

  @computed get processedData() {
    // if (!this.data?.receipts || !this.data?.receipts?.length) return;
    const items: any[] =
      this.data?.receipts?.map((item) => ({
        ...item,
        date: dateFormat(item.date, {
          format: 'DD.MM.YYYY',
          addHours: 0,
        }),
        sumReceipt: numGroup(item.sumReceipt),
      })) || [];
    items.length &&
      items.unshift({
        numReceipt: 'ИТОГО',
        sumReceipt: this.data?.totalSumReceipt.toLocaleString('Ru-ru'),
        isSummary: true,
      });

    const taxes = this.data?.taxModeInfo?.reduce<{
      [key: string]: {
        tax: number;
        exemption: number;
        total: number;
      };
    }>((acc, { accountType, tax, exemption }) => {
      acc[accountType] = {
        tax,
        exemption,
        total: tax - exemption,
      };
      return acc;
    }, {});

    return {
      ...this.data,
      items,
      sumAccrual: numGroup(this.data?.sumAccrual),
      sumDebt: numGroup(this.data?.sumDebt),
      sumDebtAccrual: numGroup(this.data?.sumDebtAccrual),
      sumPayAccrual: numGroup(this.data?.sumPayAccrual),
      sumPayTax: numGroup(this.data?.sumPayTax),
      sumTax: numGroup(this.data?.sumTax),
      SC: taxes?.SC?.tax?.toLocaleString('ru-RU'),
      SCExemption: Boolean(taxes?.SC?.exemption),
      SCTotal: taxes?.SC?.total?.toLocaleString('ru-RU'),
      MPC: taxes?.MPC?.tax?.toLocaleString('ru-RU'),
      MPCExemption: Boolean(taxes?.MPC?.exemption),
      MPCTotal: taxes?.MPC?.total?.toLocaleString('ru-RU'),
      CCSHI: taxes?.CCSHI?.tax?.toLocaleString('ru-RU'),
      CCSHIExemption: Boolean(taxes?.CCSHI?.exemption),
      CCSHITotal: taxes?.CCSHI?.total?.toLocaleString('ru-RU'),
      totalDeductions: (
        (taxes?.SC?.total || 0) +
        (taxes?.MPC?.total || 0) +
        (taxes?.CCSHI?.total || 0)
      ).toLocaleString('ru-RU'),
    };
  }

  @action.bound
  async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getTaxpayerTaxes(
        this.currentTaxpayer,
        this.filters.month,
        this.notFalsyParams,
      );
      this.data = data;
      this.overall = { totalSumReceipt: data.totalSumReceipt };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
